import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "filters-bar" }
const _hoisted_3 = { class: "date-wrapper" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_9 = { class: "btn-group-wrapper" }
const _hoisted_10 = { class: "text-yellow" }
const _hoisted_11 = { class: "adjustment-checkbox" }
const _hoisted_12 = {
  key: 0,
  class: "drag-feedback"
}
const _hoisted_13 = { class: "drag-feedback-content" }
const _hoisted_14 = {
  key: 1,
  class: "loading-overlay"
}
const _hoisted_15 = { class: "toast-content" }
const _hoisted_16 = { class: "toast-icon" }
const _hoisted_17 = { class: "toast-message" }
const _hoisted_18 = { class: "text-danger h2" }
const _hoisted_19 = {
  key: 3,
  class: "grand-total-banner"
}
const _hoisted_20 = { class: "grand-total-value" }
const _hoisted_21 = { class: "grand-total-days" }
const _hoisted_22 = {
  key: 0,
  class: "timeline-wrapper"
}
const _hoisted_23 = { class: "grid-header" }
const _hoisted_24 = { class: "day-date" }
const _hoisted_25 = { class: "day-full" }
const _hoisted_26 = { class: "day-total" }
const _hoisted_27 = { class: "grid-body" }
const _hoisted_28 = { class: "grid-cell time-cell" }
const _hoisted_29 = ["onDragover", "onDrop"]
const _hoisted_30 = ["draggable", "onClick", "onDblclick", "onDragstart"]
const _hoisted_31 = {
  key: 0,
  class: "job-checkbox"
}
const _hoisted_32 = ["checked"]
const _hoisted_33 = { class: "job-seq-circle" }
const _hoisted_34 = ["title"]
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "job-meta" }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "job-duration" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "grid-header bottom-header" }
const _hoisted_41 = { class: "day-date" }
const _hoisted_42 = { class: "day-full" }
const _hoisted_43 = { class: "day-total" }
const _hoisted_44 = {
  key: 1,
  class: "no-data"
}
const _hoisted_45 = {
  key: 2,
  class: "no-data"
}
const _hoisted_46 = {
  key: 3,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpeechSchedule = _resolveComponent("SpeechSchedule")!
  const _component_JobModal = _resolveComponent("JobModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SpeechSchedule, {
      baseUrl: _ctx.baseUrl,
      onScheduleLoaded: _ctx.onScheduleLoaded
    }, null, 8, ["baseUrl", "onScheduleLoaded"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            type: "date",
            value: _ctx.startDateInput,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateStartDate($event)))
          }, null, 40, _hoisted_4),
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "date-separator" }, "to", -1)),
          _createElementVNode("input", {
            type: "date",
            value: _ctx.endDateInput,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateEndDate($event)))
          }, null, 40, _hoisted_5)
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "col-2",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCompanyId) = $event)),
          disabled: _ctx.isLoadingCompanies
        }, [
          _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "All Clients", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
            return (_openBlock(), _createElementBlock("option", {
              key: company.companyId || company.id,
              value: company.companyId || company.id
            }, _toDisplayString(company.companyName || company.name || company.Name || 'Unknown Client'), 9, _hoisted_7))
          }), 128))
        ], 8, _hoisted_6), [
          [_vModelSelect, _ctx.selectedCompanyId]
        ]),
        (_ctx.isLoadingCompanies)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Loading clients..."))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm m-1",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.OnAddJobCliked && _ctx.OnAddJobCliked(...args)))
          }, [...(_cache[14] || (_cache[14] = [
            _createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1),
            _createTextVNode(" Add Job ", -1)
          ]))]),
          _createElementVNode("button", {
            class: "btn btn-danger btn-sm m-1",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSelectMode()))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["bi", _ctx.selectMode ? 'bi-x-circle' : 'bi-check-circle'])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.selectMode ? 'Cancel' : 'Select Mode'), 1)
          ]),
          (_ctx.selectMode && _ctx.selectedJobIds.size > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-danger btn-sm m-1",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteSelectedJobs()))
              }, [
                _cache[15] || (_cache[15] = _createElementVNode("i", {
                  class: "bi bi-trash-fill",
                  style: {"color":"black"}
                }, null, -1)),
                _createElementVNode("span", _hoisted_10, "Delete (" + _toDisplayString(_ctx.selectedJobIds.size) + ")", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("label", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.includeAdjustment) = $event)),
            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getScheduleForToday()))
          }, null, 544), [
            [_vModelCheckbox, _ctx.includeAdjustment]
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("span", null, "⏱️ Include Adjustment Hours", -1))
        ])
      ]),
      (_ctx.isDragging)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, "📋 Creating jobs from " + _toDisplayString(_ctx.dragSourceDate) + " to " + _toDisplayString(_ctx.dragTargetDate) + " (" + _toDisplayString(_ctx.dateRangeCount) + " days)", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCreatingJobs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
            _createElementVNode("div", null, "Creating " + _toDisplayString(_ctx.jobsToCreate) + " job(s)...", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showToast)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["toast-container", _ctx.toastType])
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.toastIcon), 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.toastMessage), 1),
              _createElementVNode("button", {
                class: "toast-close",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args)))
              }, "×")
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_JobModal, {
        ref: "jobModal",
        baseUrl: _ctx.baseUrl,
        officers: _ctx.officers,
        sites: _ctx.sites,
        jobStatuses: _ctx.jobStatuses,
        onJobAdded: _ctx.getScheduleForToday,
        onJobUpdated: _ctx.getScheduleForToday
      }, null, 8, ["baseUrl", "officers", "sites", "jobStatuses", "onJobAdded", "onJobUpdated"]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("span", _hoisted_18, "Please make sure you are logged in.", 512), [
          [_vShow, !_ctx.isAuthorized]
        ])
      ]),
      (_ctx.dayList.length > 0 && _ctx.hasScheduleData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "grand-total-icon" }, "📊", -1)),
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "grand-total-label" }, "Grand Total:", -1)),
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.grandTotalHours), 1),
            _createElementVNode("span", _hoisted_21, "(" + _toDisplayString(_ctx.dayList.length) + " days)", 1)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["schedule-grid", { 'select-mode-active': _ctx.selectMode }])
      }, [
        (_ctx.dayList.length > 0 && _ctx.hasAnyJobs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "header-cell time-header" }, "Time", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (day) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: day.dateKey,
                    class: "header-cell day-header"
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatDayLabel(day.date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, "⏱️ " + _toDisplayString(_ctx.dailyTotalHours[day.dateKey]), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHourList, (hour) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: hour,
                    class: "grid-row"
                  }, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatHourLabel(hour)), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: day.dateKey + '-' + hour,
                        class: _normalizeClass(["grid-cell slot-cell", { 
            'drag-over': _ctx.isDragOver && _ctx.dragOverKey === `${day.dateKey}-${hour}`,
            'has-conflict': _ctx.hasJobConflict(day, hour)
          }]),
                        onDragover: _withModifiers(($event: any) => (_ctx.onDragOver(day, hour)), ["prevent"]),
                        onDragleave: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
                        onDrop: _withModifiers(($event: any) => (_ctx.onDrop(day, hour)), ["prevent"])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobsForSlot(day, hour), (duty) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: duty.jobId,
                            class: _normalizeClass(["job-block", [
              _ctx.setStatusColor(duty.statusId), 
              { 'job-selected': _ctx.selectMode && _ctx.selectedJobIds.has(duty.jobId) }
            ]]),
                            draggable: !_ctx.selectMode,
                            onClick: ($event: any) => (_ctx.selectMode ? _ctx.toggleJobSelection(duty.jobId) : _ctx.openEditJob(duty)),
                            onDblclick: ($event: any) => (!_ctx.selectMode && _ctx.openEditJob(duty)),
                            onDragstart: ($event: any) => (!_ctx.selectMode && _ctx.onDragStart($event, duty, day, hour)),
                            onDragend: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)))
                          }, [
                            (_ctx.selectMode)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.selectedJobIds.has(duty.jobId),
                                    onChange: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 40, _hoisted_32)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.jobSequenceMap[duty.jobId]), 1),
                            _createElementVNode("div", {
                              class: "job-title",
                              title: duty.securityOfficerInfo
                            }, _toDisplayString(_ctx.formatOfficerName(duty.securityOfficerInfo, _ctx.dayList.length)), 9, _hoisted_34),
                            _createElementVNode("div", {
                              class: "job-site-name",
                              title: duty.siteInfo
                            }, _toDisplayString(_ctx.formatSiteName(duty.siteInfo, _ctx.dayList.length)), 9, _hoisted_35),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("span", {
                                class: "job-time",
                                title: _ctx.getTimeTooltip(duty)
                              }, _toDisplayString(_ctx.formatTimeSpan(duty.startTime)) + "–" + _toDisplayString(_ctx.formatTimeSpan(duty.endTime)), 9, _hoisted_37),
                              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.calculateJobDuration(duty.startTime, duty.endTime)), 1),
                              _createElementVNode("span", {
                                class: "job-client",
                                title: duty.clientInfo
                              }, _toDisplayString(_ctx.formatClientName(duty.clientInfo, _ctx.dayList.length)), 9, _hoisted_39)
                            ])
                          ], 42, _hoisted_30))
                        }), 128))
                      ], 42, _hoisted_29))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "header-cell time-header" }, "Time", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (day) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'bottom-' + day.dateKey,
                    class: "header-cell day-header"
                  }, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.formatDayLabel(day.date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, "⏱️ " + _toDisplayString(_ctx.dailyTotalHours[day.dateKey]), 1)
                  ]))
                }), 128))
              ])
            ]))
          : (_ctx.dayList.length > 0 && !_ctx.hasAnyJobs && _ctx.isAuthorized && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, " No jobs found for selected dates "))
            : (_ctx.dayList.length === 0 && _ctx.isAuthorized && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, " No schedule data available for selected dates "))
              : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, " Loading schedule data... "))
          : _createCommentVNode("", true)
      ], 2), [
        [_vShow, _ctx.isAuthorized]
      ])
    ])
  ], 64))
}